import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import { Row } from 'antd-v5';
import { Icon } from 'UI';
import { Country } from 'utils/i18n/Country';
import { SSelect } from './CountrySelect.styled';

const { Option } = Select;

interface Props {
  countryList: Array<Country>;
  selected: Country | Country[];
  onSelect: (selected: Country) => void;
  onDeselect?: (deselected: Country) => void;
  disabled?: boolean;
  allowClear?: boolean;
}

const CountrySelect = ({
  countryList,
  selected,
  onSelect,
  onDeselect,
  disabled = false,
  allowClear = false,
}: Props) => {
  const { t } = useTranslation();
  const sortedCountryList = [...countryList].sort((l1: Country, l2: Country) => l1.name.localeCompare(l2.name));

  function findCountry(country: string): Country {
    return countryList.find((item) => item.key === country) ?? Country.DEFAULT;
  }

  return (
    <SSelect
      mode={Array.isArray(selected) ? 'multiple' : undefined}
      allowClear={allowClear}
      showSearch={false}
      disabled={disabled}
      placeholder={t('common.select_country', 'Select country')}
      value={Array.isArray(selected) ? selected.map((s) => s.key) : selected.key}
      filterOption={(input, option) => option?.title.toLowerCase().indexOf(input.toLowerCase()) >= 0}
      optionFilterProp="label"
      onSelect={(countryKey: string) => {
        onSelect(findCountry(countryKey));
      }}
      onDeselect={(countryKey: string) => {
        onDeselect?.(findCountry(countryKey));
      }}
      showArrow
    >
      {sortedCountryList.map(({ key, name, icon }) => (
        <Option key={key} value={key} title={name} data-cy={`country-dropdown-choice-${key}`}>
          <Row>
            <Icon IconComponent={icon} size={16} color={'black'} mt={3} mr={10} />
            &nbsp; {name}
          </Row>
        </Option>
      ))}
    </SSelect>
  );
};

export default CountrySelect;
